<template>
  <div>
    <div class="notification is-default" :style="divStyle">
      {{ attributes.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SceneRawText',
  props: ['attributes'],
  computed: {
    divStyle () {
      return {
        'padding-top': this.attributes.paddingtop,
        'padding-bottom': this.attributes.paddingbottom
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .notification
    white-space: pre-line
    padding-left: 25px
    padding-right: 25px
    margin-bottom: 10px
    margin-top: 10px
</style>
